import React from "react";
import { Modal } from "flowbite-react";
import { Button } from "../buttons";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { Icon } from "../icons";
import { formatDate } from "../../utils/datetime-utils";
import { TextLink } from "../link";
import { JUDGMENT } from "../../constants/routes";
import { useNavigate } from "react-router-dom";

const ModalNotifications = ({
  openModal,
  setOpenModal,
  children,
  size,
  notifications,
  listMachineGroup,
  readNotifications,
}) => {
  const navigate = useNavigate();
  const handleReadNotifications = (row) => {
    readNotifications(row);
    const link = `${JUDGMENT}/?workflow=${
      row?.workflow?.id
    }&start_date=${formatDate(row?.start_datetime)}&end_date=${formatDate(
      row?.end_datetime
    )}`;
    navigate(link);
  };

  return (
    <Modal
      show={openModal}
      onClose={() => setOpenModal(false)}
      theme={tenkenTheme}
      size={size}
    >
      <Modal.Header>
        <div className="flex">
          <div className="pt-1">
            <Icon name="sidebar-judgment" size={24} />
          </div>
          <div className="ml-2">通知</div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <span>未承認の点検があります。</span>
        <div className="flex mt-5">
          <div className="min-w-[40px]"></div>
          <div className="px-4 py-2 min-w-[240px]">承認設定名</div>
          <div className="px-4 py-2 min-w-[240px]">点検テンプレート名</div>
          <div className="px-4 py-2 min-w-[320px]">設備グループ</div>
          <div className="px-4 py-2 min-w-[120px]">直近点検日</div>
        </div>
        {notifications.map((row, idx) => (
          <div className="flex" key={idx}>
            <div className="px-4 py-2 w-[40px]">{idx + 1}</div>
            <div
              className="px-4 py-2 min-w-[240px] max-w-[240px] truncate text-[#2374fd] hover:text-[#5898ff] cursor-pointer"
              onClick={() => handleReadNotifications(row)}
            >
              <span title={row?.workflow?.name}>{row?.workflow?.name}</span>
            </div>
            <div className="px-4 py-2 min-w-[240px] max-w-[240px] truncate">
              <span title={row?.inspection?.template?.name}>
                {row?.inspection?.template?.name}
              </span>
            </div>
            <div className="px-4 py-2 min-w-[320px] max-w-[320px] truncate">
              {listMachineGroup(row?.inspection?.template)}
            </div>
            <div className="px-4 py-2 w-[120px]">
              {formatDate(row?.end_datetime)}
            </div>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer className="flex justify-center">
        <Button
          className="w-[120px] rounded"
          theme={tenkenTheme.button}
          color="primary"
          onClick={() => setOpenModal(false)}
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalNotifications;
